import { createFileRoute } from "@tanstack/react-router";
import { ReservedHostPage } from "../../features/reserved-hosts/servers";

export const Route = createFileRoute("/_authed/$org/$project/reservedhosts/$name/$tab")({ component: Server });
function Server() {
  const { org, project, name } = Route.useParams();
  return <ReservedHostPage scope={{ org, project }} name={name} />;
}
